import React, { useEffect } from 'react';
import { guideType, maxBasedBrokerId, monopattiniPackage } from '../../constants';
import {
  QuoteInformationContainer,
  QuoteInformationItem,
} from '../../components/redesignComponents/ResultPageComponents/v2/QuotationCard.styles';

function QuoteInfoComponent({
  quote,
  requestInfo,
  profession,
  type,
  setExtraText,
}) {
  useEffect(() => {
    let defaultText = '';

    if (quote.company_id != 15) {
      defaultText += `Frequenza pagamento: ${quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'
      } `;
    }
    if (requestInfo?.guide_type) {
      defaultText += `- Guida: ${guideType.find((v) => v.id === requestInfo.guide_type).name
      } `;
    }
    if (quote.company_id === 1) {
      defaultText
        += "- Emissione: Tradizionale -  Risarcimento: Rc con Risarcimento Diretto e RFS - Massimale: 6'450'000€  Danni a persone, 1'050'000€ Danni a cose";
    }

    if (
      quote.company_id === 3
      || quote.company_id === 9
      || quote.company_id === 10
      || quote.company_id === 17
      || quote.company_id === 21
      || quote.company_id === 22
      || quote.added_manually === 1
      || (quote.added_manually === 0 && quote.company_id === null)
    ) {
      defaultText
        += "- Emissione: Tradizionale -  Risarcimento: Rc con Risarcimento Diretto e RFS - Massimale: 6'450'000€  Danni a persone, 1'050'000€ Danni a cose";
    }

    if (quote.company_id === 2) {
      defaultText
        += "- Emissione: Diretta -  Risarcimento: Rc con Risarcimento Diretto e RFS - Massimale: 6'450'000€  Danni a persone, 1'050'000€ Danni a cose";
    }

    if (
      quote.company_id === 11
      || quote.company_id === 12
      || quote.company_id === 13
      || quote.company_id === 14
    ) {
      defaultText
        += '- Emissione: Tradizionale -  Risarcimento: Rc con Risarcimento Diretto e RFS';
      if (quote.massimale != 0) {
        defaultText += `- Massimale: ${quote.massimale}`;
      }
      if (quote.isotermici) {
        defaultText += `- Isotermici: ${quote.isotermici}`;
      }
    }

    if (quote.company_id === 16) {
      defaultText += '- Emissione: Tradizionale ';
      if (quote.massimale != 0) {
        defaultText += `- Massimale: ${new Intl.NumberFormat().format(
          quote.massimale,
        )}`;
      }
    }

    if (quote.company_id === 4) {
      defaultText += `Professione: ${profession.profession_desc
      } - Massimale: ${Number(profession.billed_maximum).toLocaleString(
        'it-IT',
        {
          minimumFractionDigits: 2,
        },
      )} - Franchigia: 1,000€ - Retroattività: ${profession.retroactivity_name
      } - Scaglione fatturato: ${profession.billed
      } - Tempo medio di emissione: 2 giorni`;
    }

    if (quote.company_id === 1002) {
      defaultText += `Professione: ${profession.profession_desc} - Massimale: ${Number(profession.billed_maximum).toLocaleString('it-IT', { minimumFractionDigits: 2 })} - Retroattività: ${profession.retroactivity_name} - Scaglione fatturato: ${profession.billed}`;
    }

    if (quote.company_id === 8 && quote.product_id == 11) {
      if (quote.risk_massimale) {
        defaultText += `- Massimale: ${Number(
          quote.risk_massimale.replace(/[,.](?=\d{3})/g, '').replace(',', '.'),
        ).toLocaleString('it-IT', { minimumFractionDigits: 2 })} €`;
      }
      if (quote.massimale) {
        defaultText += `- Massimale: ${Number(
          quote.massimale.replace(/[,.](?=\d{3})/g, '').replace(',', '.'),
        ).toLocaleString('it-IT', { minimumFractionDigits: 2 })} €`;
      }
    }
    if (quote.company_id === 8 && quote.product_id == 13) {
      defaultText += '- Emissione: Tradizionale ';
      if (quote.massimale != 0 && quote.massimale !== null) {
        defaultText += `- Massimale: ${new Intl.NumberFormat().format(
          quote.massimale,
        )} €`;
      }
      if (quote.quote_type === 'collisione') {
        defaultText += '- Franchigia: 200 €';
      }
    }

    if (quote.company_id === 15) {
      defaultText += '- Emissione: Tradizionale - Frequenza pagamento: Annuo';
      if (quote.massimale != 0) {
        defaultText += `- Massimale: ${parseFloat(quote.massimale).toFixed(
          2,
        )} €`;
      }
    }

    if (quote.company_id === 8 && quote.product_id == 12) {
      if (quote.risk_massimale) {
        defaultText += `- Massimale: ${Number(
          quote.risk_massimale.replace(/[,.](?=\d{3})/g, '').replace(',', '.'),
        ).toLocaleString('it-IT', { minimumFractionDigits: 2 })} €`;
      }
      if (quote.massimale) {
        defaultText += `- Massimale: ${Number(
          quote.massimale.replace(/[,.](?=\d{3})/g, '').replace(',', '.'),
        ).toLocaleString('it-IT', { minimumFractionDigits: 2 })} €`;
      }
    }

    if (requestInfo.product_id == 1000 && quote.company_id === 19 && quote.massimale) {
      defaultText += `- Massimale: ${Number(
        quote.massimale.replace(/[,.](?=\d{3})/g, '').replace(',', '.'),
      ).toLocaleString('it-IT', { minimumFractionDigits: 2 })} €`;
    }

    if (quote.product_name) {
      defaultText += `- Nome Prodotto: ${quote.product_name}`;
    }

    setExtraText(defaultText);
  }, [quote]);

  const getSubProductName = (subProduct) => {
    if (subProduct === 'professioni_sanitarie') return 'Professioni Sanitarie';
    if (subProduct === 'medici_dipendenti') return 'Medici Dipendenti';
    if (subProduct === 'medico_protetto') return 'Medico Protetto';
    if (subProduct === 'medici_liberi_professionisti') return 'Medici Liberi Professionisti';

    return '';
  };

  return (
    <>
      {quote.company_id === 1 && (
        <>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>Adriatic Assicurazioni</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Guida:</h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationItem>
          </QuoteInformationContainer>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Risarcimento:</h6>
              <p>
                Rc con
                {' '}
                <b>Risarcimento</b>
                {' '}
                <br />
                {' '}
                <b>Diretto</b>
                {' '}
                e
                {' '}
                <b>RFS</b>
              </p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Massimale:</h6>
              <p>
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                  &euro;
                </b>
                {' '}
                Danni a persone
                <br />
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                  &euro;
                </b>
                {' '}
                Danni a cose
              </p>
            </QuoteInformationItem>
          </QuoteInformationContainer>
        </>
      )}
      {(quote.company_id === 3
        || quote.company_id === 9
        || quote.company_id === 10
        || quote.company_id === 17
        || quote.company_id === 21
        || quote.company_id === 22

        || quote.added_manually === 1
        || (quote.added_manually === 0 && quote.company_id === null)) && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>
                  {quote.company
                    ? quote.company.name
                    : quote.preventivas_company?.company_name || 'N/A'}
                </p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Emissione:</h6>
                <p>Tradizionale</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Guida:</h6>
                <p>
                  {requestInfo.guide_type
                    ? guideType.find((v) => v.id === requestInfo.guide_type)?.name
                    : quote.quotation_data_facile?.typeOfDrive
                      ? quote.quotation_data_facile.typeOfDrive.charAt(0).toUpperCase() + quote.quotation_data_facile.typeOfDrive.slice(1)
                      : 'N/A'}
                </p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Risarcimento:</h6>
                <p>
                  Rc con
                  {' '}
                  <b>Risarcimento</b>
                  {' '}
                  <br />
                  {' '}
                  <b>Diretto</b>
                  {' '}
                  e
                  {' '}
                  <b>RFS</b>
                </p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  {quote.quotation_data_facile?.coverages
                    ? (() => {
                      const rcaCoverage = quote.quotation_data_facile.coverages.find((c) => c.code === 'rca');
                      return rcaCoverage?.maximal || (
                        <>
                          <b>
                            {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                          </b>
                          {' '}
                          Danni a persone
                          <br />
                          <b>
                            {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                            & euro;
                          </b>
                          {' '}
                          Danni a cose
                        </>
                      );
                    })()
                    : (
                      <>
                        <b>
                          {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                          & euro;
                        </b>
                        {' '}
                        Danni a persone
                        <br />
                        <b>
                          {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                          & euro;
                        </b>
                        {' '}
                        Danni a cose
                      </>
                    )}
                </p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
          </>
      )}
      {
        quote.company_id === 18
        && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>
                  {quote.company
                    ? quote.company.name
                    : quote.preventivas_company.company_name}
                </p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Emissione:</h6>
                <p>Tradizionale</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Guida:</h6>
                <p>
                  {guideType.find((v) => v.id === requestInfo.guide_type).name}
                </p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Risarcimento:</h6>
                <p>
                  Rc con
                  {' '}
                  <b>Risarcimento</b>
                  {' '}
                  <br />
                  {' '}
                  <b>Diretto</b>
                  {' '}
                  e
                  {' '}
                  <b>RFS</b>
                </p>
              </QuoteInformationItem>
              {quote.risk_massimale
                && (
                  <QuoteInformationItem>
                    <h6>Massimale:</h6>
                    <p>
                      {quote.risk_massimale}
                    </p>
                  </QuoteInformationItem>
                )}
              {quote.massimale
                && (
                  <QuoteInformationItem>
                    <h6>Massimale:</h6>
                    <p>
                      {quote.massimale}
                    </p>
                  </QuoteInformationItem>
                )}
            </QuoteInformationContainer>
          </>
        )
      }
      {
        quote.company_id === 2 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote && quote.quotation_data_prima ? quote.quotation_data_prima.issuing_company : 'Ipitq ma'}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Emissione:</h6>
                <p>Diretta</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Guida:</h6>
                <p>
                  {guideType.find((v) => v.id === requestInfo.guide_type).name}
                </p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Risarcimento:</h6>
                <p>
                  Rc con
                  {' '}
                  <b>Risarcimento</b>
                  {' '}
                  <br />
                  {' '}
                  <b>Diretto</b>
                  {' '}
                  e
                  {' '}
                  <b>RFS</b>
                </p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  <b>
                    {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                    &euro;
                  </b>
                  {' '}
                  Danni a persone
                  <br />
                  <b>
                    {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                    &euro;
                  </b>
                  {' '}
                  Danni a cose
                </p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
          </>
        )
      }
      {
        (quote.company_id === 11
          || quote.company_id === 12
          || quote.company_id === 13
          || quote.company_id === 14) && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Emissione:</h6>
                <p>Tradizionale</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Guida:</h6>
                <p>
                  {guideType.find((v) => v.id === requestInfo.guide_type).name}
                </p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Risarcimento:</h6>
                <p>
                  Rc con
                  {' '}
                  <b>Risarcimento</b>
                  {' '}
                  <br />
                  {' '}
                  <b>Diretto</b>
                  {' '}
                  e
                  {' '}
                  <b>RFS</b>
                </p>
              </QuoteInformationItem>
              {quote.massimale != 0 && (
                <QuoteInformationItem>
                  <h6>Massimale:</h6>
                  <p>{quote.massimale}</p>
                </QuoteInformationItem>
              )}
              <QuoteInformationItem>
                <h6>Isotermici:</h6>
                <p>{quote.isotermici}</p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
          </>
        )
      }
      {
        quote.company_id === 16 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>Global Assistance</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Emissione:</h6>
                <p>Tradizionale</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Prodotto:</h6>
                <p>{quote.product_name}</p>
              </QuoteInformationItem>
              {quote.massimale != 0 && quote.massimale !== null && (
                <QuoteInformationItem>
                  <h6>Massimale:</h6>
                  <p>
                    {quote.product_id !== 11 && quote.product_id !== 16 ? `${new Intl.NumberFormat().format(quote.massimale)} €` : quote.massimale}
                  </p>
                </QuoteInformationItem>
              )}
              {
                quote.product_id === 9
                && (
                  <>
                    {(quote.sub_product === 'patente_motor') && (
                      <>
                        <QuoteInformationItem>
                          <h6>Specifiche:</h6>
                          <p>
                            {quote.information}
                          </p>
                        </QuoteInformationItem>
                        {quote.quote_massimale
                          && (
                            <QuoteInformationItem>
                              <h6>Massimale:</h6>
                              <p>
                                {new Intl.NumberFormat().format(quote.quote_massimale)}
                                €
                              </p>
                            </QuoteInformationItem>
                          )}
                      </>
                    )}

                    {(quote.sub_product === 'vita_privata' || quote.sub_product === 'tutela_professionale') && (
                      <>

                        {quote.quote_massimale
                          && (
                            <QuoteInformationItem>
                              <h6>Massimale:</h6>
                              <p>
                                {new Intl.NumberFormat().format(quote.quote_massimale)}
                                €
                              </p>
                            </QuoteInformationItem>
                          )}
                      </>
                    )}
                  </>
                )
              }
              {/* {(quote.quote_type === 'tutela_legale_vita_privata') && (
              <>
                <QuoteInformationItem>
                  <h6>Incluso:</h6>
                  <p>Cyber Risk 25€</p>
                </QuoteInformationItem>
                <QuoteInformationItem>
                  <h6>Incluso:</h6>
                  <p>Animali Domestici 19.99€</p>
                </QuoteInformationItem>
              </>
            )} */}
            </QuoteInformationContainer>
          </>
        )
      }
      {quote.company_id === 8 && quote.product_id === 14 && (
        <>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationItem>
          </QuoteInformationContainer>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Prodotto:</h6>
              <p>{quote.product_name}</p>
            </QuoteInformationItem>
            {quote.massimale != 0 && quote.massimale !== null && (
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  {new Intl.NumberFormat('it-IT').format(quote.massimale)}
                  {' '}
                  &euro;
                </p>
              </QuoteInformationItem>
            )}
            {
              quote.product_id === 9
              && (
                <>
                  {(quote.sub_product === 'patente_motor') && (
                    <>
                      <QuoteInformationItem>
                        <h6>Specifiche:</h6>
                        <p>
                          {quote.information}
                        </p>
                      </QuoteInformationItem>
                      {quote.quote_massimale
                        && (
                          <QuoteInformationItem>
                            <h6>Massimale:</h6>
                            <p>
                              {new Intl.NumberFormat().format(quote.quote_massimale)}
                              €
                            </p>
                          </QuoteInformationItem>
                        )}
                    </>
                  )}

                  {(quote.sub_product === 'vita_privata' || quote.sub_product === 'tutela_professionale') && (
                    <>

                      {quote.quote_massimale
                        && (
                          <QuoteInformationItem>
                            <h6>Massimale:</h6>
                            <p>
                              {new Intl.NumberFormat().format(quote.quote_massimale)}
                              €
                            </p>
                          </QuoteInformationItem>
                        )}
                    </>
                  )}
                </>
              )
            }
            {/* {(quote.quote_type === 'tutela_legale_vita_privata') && (
              <>
                <QuoteInformationItem>
                  <h6>Incluso:</h6>
                  <p>Cyber Risk 25€</p>
                </QuoteInformationItem>
                <QuoteInformationItem>
                  <h6>Incluso:</h6>
                  <p>Animali Domestici 19.99€</p>
                </QuoteInformationItem>
              </>
            )} */}
          </QuoteInformationContainer>
        </>
      )}
      {quote.company_id === 4 && (
        <>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Prodotto:</h6>
              <p>RC Professionale</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Professione:</h6>
              <p>{profession.profession_desc}</p>
            </QuoteInformationItem>
            {profession.billed_maximum != 0 && (
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(profession.billed_maximum).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  &euro;
                </p>
              </QuoteInformationItem>
            )}
          </QuoteInformationContainer>
          <QuoteInformationContainer className="ms-3 ms-sm-0">
            <QuoteInformationItem>
              <h6>Franchigia:</h6>
              <p>1.000,00&euro;</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Retroattività:</h6>
              <p>{profession.retroactivity_name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Scaglione fatturato:</h6>
              <p>
                {Number(profession.billed).toLocaleString('it-IT', {
                  minimumFractionDigits: 2,
                })}
                &euro;
              </p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Tempo medio di emissione:</h6>
              <p>2 giorni</p>
            </QuoteInformationItem>
          </QuoteInformationContainer>
        </>
      )}
      {quote.company_id === 1002 && (
        <>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Prodotto:</h6>
              <p>RC Professionale</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Professione:</h6>
              <p>{profession.profession_desc}</p>
            </QuoteInformationItem>
            {profession.billed_maximum != 0 && (
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(profession.billed_maximum).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  &euro;
                </p>
              </QuoteInformationItem>
            )}
          </QuoteInformationContainer>
          <QuoteInformationContainer className="ms-3 ms-sm-0">
            {quote.deductible
              && (
                <QuoteInformationItem>
                  <h6>Franchigia:</h6>
                  {Number(quote.deductible).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  &euro;
                </QuoteInformationItem>
              )}
            {quote.deductible_plus
              && (
                <QuoteInformationItem>
                  <h6>Franchigia Incarichi:</h6>
                  {Number(quote.deductible_plus).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  &euro;
                </QuoteInformationItem>
              )}
            {profession.retroactivity_name
              && (
                <QuoteInformationItem>
                  <h6>Retroattività:</h6>
                  <p>{profession.retroactivity_name}</p>
                </QuoteInformationItem>
              )}
            {profession.billed
              && (
                <QuoteInformationItem>
                  <h6>Scaglione fatturato:</h6>
                  <p>
                    {Number(profession.billed).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                    })}

                    &euro;
                  </p>
                </QuoteInformationItem>
              )}

          </QuoteInformationContainer>
        </>
      )}
      {
        quote.company_id === 8 && quote.product_id == 11 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Prodotto:</h6>
                <p>{requestInfo.product.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Nome Prodotto:</h6>
                <p>{quote.product_name}</p>
              </QuoteInformationItem>
              {quote.risk_massimale && (
                <QuoteInformationItem>
                  <h6>Massimale:</h6>
                  <p>
                    {Number(
                      quote.risk_massimale
                        .replace(/[,.](?=\d{3})/g, '')
                        .replace(',', '.'),
                    ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                    &euro;
                  </p>
                </QuoteInformationItem>
              )}
              {quote.massimale && (
                <QuoteInformationItem>
                  <h6>Massimale:</h6>
                  <p>
                    {Number(
                      quote.massimale
                        .replace(/[,.](?=\d{3})/g, '')
                        .replace(',', '.'),
                    ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                    &euro;
                  </p>
                </QuoteInformationItem>
              )}
            </QuoteInformationContainer>
          </>
        )
      }
      {
        quote.company_id === 1001 && quote.product_id == 11 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Prodotto:</h6>
                <p>{requestInfo.product.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Nome Prodotto:</h6>
                <p>{quote.product_name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  Tra &euro; 30,000 e &euro; 500,000
                </p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
          </>
        )
      }
      {
        quote.company_id === 8 && quote.product_id == 13 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Emissione:</h6>
                <p>Tradizionale</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Prodotto:</h6>
                <p>{quote.product_name}</p>
              </QuoteInformationItem>
              {quote.massimale != 0 && quote.massimale !== null && (
                <QuoteInformationItem>
                  <h6>Massimale:</h6>
                  <p>
                    {new Intl.NumberFormat().format(quote.massimale)}
                    €
                  </p>
                </QuoteInformationItem>
              )}
              {quote.quote_type === 'collisione' && (
                <QuoteInformationItem>
                  <h6>Franchigia</h6>
                  <p>200 €</p>
                </QuoteInformationItem>
              )}
            </QuoteInformationContainer>
          </>
        )
      }

      {
        quote.company_id === 15 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Prodotto:</h6>
                <p>{quote.sub_product ? 'Tutela Legale' : type.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Emissione:</h6>
                <p>Tradizionale</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Frequenza pagamento:</h6>
                <p>Annuo</p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
            <QuoteInformationContainer>
              {quote.massimale != 0 && quote.massimale != null && (
                <QuoteInformationItem>
                  <h6>Massimale:</h6>
                  <p>
                    {Number(quote.massimale).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                    })}
                    &euro;
                  </p>
                </QuoteInformationItem>
              )}
              {quote.risk_massimale != 0 && quote.risk_massimale != null && (
                <QuoteInformationItem>
                  <h6>Massimale:</h6>
                  <p>

                    {Number(quote.risk_massimale).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                    })}
                    &euro;
                  </p>
                </QuoteInformationItem>
              )}
              <QuoteInformationItem>
                <h6>Nome Prodotto:</h6>
                <p>{quote.product_name}</p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
          </>
        )
      }
      {
        quote.company_id === 8 && quote.product_id == 12 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Prodotto:</h6>
                <p>{requestInfo.product.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Nome Prodotto:</h6>
                <p>{quote.product_name}</p>
              </QuoteInformationItem>
              {/* {quote.risk_massimale && (
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(
                    quote.risk_massimale
                      .replace(/[,.](?=\d{3})/g, '')
                      .replace(',', '.'),
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  &euro;
                </p>
              </QuoteInformationItem>
            )} */}
              {quote.quote_type === 'adattamento_abitazione_malattia'
                && (
                  <QuoteInformationItem>
                    <h6>Massimale:</h6>
                    <p>
                      5.000,00
                      {' '}
                      &euro;
                    </p>
                  </QuoteInformationItem>
                )}
              {quote.quote_type === 'indennita_sostitutiva_malattia'
                && (
                  <QuoteInformationItem>
                    <h6>Massimale:</h6>
                    <p>
                      100,00 &euro;/giorno per 100 giorni
                    </p>
                  </QuoteInformationItem>
                )}
              {quote.quote_type === 'daria_da_convalescenza_malattia'
                && (
                  <QuoteInformationItem>
                    <h6>Massimale:</h6>
                    <p>
                      100,00 &euro;/giorno per 20 giorni
                    </p>
                  </QuoteInformationItem>
                )}

              {quote.quote_type === 'rsm_post_ricovero_malattia'
                && (
                  <QuoteInformationItem>
                    <h6>Visite specialistiche ed esami diagnostici: </h6>
                    <p>
                      5.000,00 €
                    </p>
                  </QuoteInformationItem>
                )}
              {quote.quote_type === 'rsm_post_ricovero_malattia'
                && (
                  <QuoteInformationItem>
                    <h6>Terapie oncologiche:</h6>
                    <p>
                      5.000,00 €
                    </p>
                  </QuoteInformationItem>
                )}
              {quote.quote_type === 'assistenza_post_infortunio'
                && (
                  <QuoteInformationItem>
                    <h6>Massimale:</h6>
                    <p>
                      1.000,00 €
                    </p>
                  </QuoteInformationItem>
                )}
              {quote.quote_type === 'adattamento_abitazione_veicolo_infortunio'
                && (
                  <QuoteInformationItem>
                    <h6>Massimale:</h6>
                    <p>
                      5.000,00 €
                    </p>
                  </QuoteInformationItem>
                )}
              {quote.quote_type === 'rsm_post_infortunio'
                && (
                  <QuoteInformationItem>
                    <h6>Massimale:</h6>
                    <p>
                      3.000,00 €
                    </p>
                  </QuoteInformationItem>
                )}
              {quote.massimale && (
                <QuoteInformationItem>
                  <h6>Massimale:</h6>
                  <p>
                    {Number(
                      quote.massimale
                        .replace(/[,.](?=\d{3})/g, '')
                        .replace(',', '.'),
                    ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                    &euro;
                  </p>
                </QuoteInformationItem>
              )}
            </QuoteInformationContainer>
          </>
        )
      }

      {
        quote.company_id === 19 && quote.product_id === 15 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Prodotto:</h6>
                <p>{requestInfo.product.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Sub Prodotto:</h6>
                <p>{getSubProductName(quote.sub_product)}</p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
            <QuoteInformationContainer className="ms-3 ms-sm-0">
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(quote.massimale).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  {' '}
                  &euro;
                </p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
          </>
        )
      }

      {
        quote.company_id === 19 && quote.product_id === 1000 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Prodotto:</h6>
                <p>{requestInfo.product.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationItem>
              {quote.massimale
                && (
                  <QuoteInformationItem>
                    <h6>Massimale:</h6>
                    <p>
                      {Number(quote.massimale).toLocaleString('it-IT', {
                        minimumFractionDigits: 2,
                      })}
                      {' '}
                      &euro;
                    </p>
                  </QuoteInformationItem>
                )}
            </QuoteInformationContainer>
            {quote.quote_type == 'invalidita_permanente_da_infortunio'
              && (
                <QuoteInformationContainer>
                  <QuoteInformationItem>
                    <h6>Franchigia:</h6>
                    <p>
                      3%
                    </p>
                  </QuoteInformationItem>

                </QuoteInformationContainer>
              )}
            {quote.quote_type == 'tutela_legale'
              && (
                <QuoteInformationContainer>
                  <QuoteInformationItem>
                    <h6>Scoperto:</h6>
                    <p>
                      10% con minimo di € 1.500,00
                    </p>
                  </QuoteInformationItem>

                </QuoteInformationContainer>
              )}
          </>
        )
      }

      {
        quote.company_id === 1000 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Emissione:</h6>
                <p>Diretta</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Guida:</h6>
                <p>
                  {guideType.find((v) => v.id === requestInfo.guide_type).name}
                </p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationItem>
            </QuoteInformationContainer>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Risarcimento:</h6>
                <p>
                  Rc con
                  {' '}
                  <b>Risarcimento</b>
                  {' '}
                  <br />
                  {' '}
                  <b>Diretto</b>
                  {' '}
                  e
                  {' '}
                  <b>RFS</b>
                </p>
              </QuoteInformationItem>
              {/* <QuoteInformationItem>
              <h6>Massimale:</h6>
              <p>
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                  &euro;
                </b>
                {' '}
                Danni a persone
                <br />
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                  &euro;
                </b>
                {' '}
                Danni a cose
              </p>
            </QuoteInformationItem> */}
            </QuoteInformationContainer>
          </>
        )
      }

      {
        quote.company_id === 19 && quote.product_id === 1002 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Prodotto:</h6>
                <p>{requestInfo.product.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Emissione:</h6>
                <p>Tradizionale</p>
              </QuoteInformationItem>

              {quote.massimale
                && (
                  <QuoteInformationItem>
                    <h6>Massimale:</h6>
                    <p>
                      {Number(quote.massimale).toLocaleString('it-IT', {
                        minimumFractionDigits: 2,
                      })}
                      {' '}
                      &euro;
                    </p>
                  </QuoteInformationItem>
                )}

              <QuoteInformationItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationItem>

            </QuoteInformationContainer>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Nome Prodotto:</h6>
                <p>{quote.product_name}</p>

              </QuoteInformationItem>
            </QuoteInformationContainer>

            <QuoteInformationContainer>

              <QuoteInformationItem>
                <h6>
                  Operatività della copertura:
                </h6>
                <p>
                  H24 per il Contraente/Assicurato
                  <br />
                  Rischio Extra-Professionale per gli Assicurati Addizionali, componenti il Nucleo Familiare
                </p>
              </QuoteInformationItem>

            </QuoteInformationContainer>

          </>
        )
      }
      {
        quote.company_id === 1001 && quote.product_id != 11 && (
          <>
            <QuoteInformationContainer>
              <QuoteInformationItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Prodotto:</h6>
                <p>
                  {requestInfo?.product?.id === 1 && 'RC Auto'}
                  {requestInfo?.product_id == 10 && 'Commercio Su Misura'}
                  {(requestInfo.product_id == 1001 || requestInfo.product_id == 1004) && quote.product_name}
                  {requestInfo.product_id == 1003 && requestInfo.product.name}

                </p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Emissione:</h6>
                <p>Tradizionale</p>
              </QuoteInformationItem>
              <QuoteInformationItem>
                <h6>Frequenza pagamento:</h6>
                <p>
                  {quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}
                </p>
              </QuoteInformationItem>
            </QuoteInformationContainer>

            <QuoteInformationContainer>
              {quote.massimale && (
                <QuoteInformationItem>
                  <h6>Massimale:</h6>
                  <p>
                    {new Intl.NumberFormat().format(quote.massimale)}
                    €
                  </p>
                </QuoteInformationItem>
              )}

              {requestInfo.product_id == 1003
                && (
                  <QuoteInformationItem>
                    <h6>Nome Prodotto:</h6>
                    <p>
                      {quote.product_name}
                    </p>
                  </QuoteInformationItem>
                )}
            </QuoteInformationContainer>
            {quote.product_id === 1 && (
              <QuoteInformationContainer>
                <QuoteInformationItem>
                  <h6>Risarcimento:</h6>
                  <p>
                    Rc con
                    {' '}
                    <b>Risarcimento</b>
                    {' '}
                    <br />
                    {' '}
                    <b>Diretto</b>
                    {' '}
                    e
                    {' '}
                    <b>RFS</b>
                  </p>
                </QuoteInformationItem>
                <QuoteInformationItem>
                  <h6>Massimale:</h6>
                  <p>
                    <b>
                      {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                      &euro;
                    </b>
                    {' '}
                    Danni a persone
                    <br />
                    <b>
                      {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                      &euro;
                    </b>
                    {' '}
                    Danni a cose
                  </p>
                </QuoteInformationItem>
              </QuoteInformationContainer>
            )}

          </>
        )
      }

      {quote.company_id === 1006 && quote.product_id === 1006 && (
        <>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationItem>

          </QuoteInformationContainer>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Paccheto:</h6>
              <p>{monopattiniPackage.find((e) => e.id === quote.code).name}</p>
            </QuoteInformationItem>

            {quote.massimale
              && (
                <QuoteInformationItem>
                  <h6>Massimale:</h6>
                  <p>
                    <b>
                      {Number(quote.massimale).toLocaleString('it-IT', {
                        minimumFractionDigits: 2,
                      })}
                      &euro;
                    </b>
                    {' '}
                    Danni a persone
                    <br />
                    <b>
                      {Number(10000).toLocaleString('it-IT', {
                        minimumFractionDigits: 2,
                      })}
                      &euro;
                    </b>
                    {' '}
                    Danni a cose
                  </p>
                </QuoteInformationItem>
              )}
          </QuoteInformationContainer>
        </>
      )}

      {(quote.company_id === 1010 && quote.product_id == 1) && (
        <>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>{quote?.company?.name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Guida:</h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationItem>
            {quote?.risk_massimale && (
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  {quote.risk_massimale}
                </p>
              </QuoteInformationItem>
            )}
          </QuoteInformationContainer>
        </>
      )}
      {(quote.company_id === 1011 && quote.product_id == 1) && (
        <>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>{quote?.company?.name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Guida:</h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationItem>
            {quote?.risk_massimale && (
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  {quote.risk_massimale}
                </p>
              </QuoteInformationItem>
            )}
          </QuoteInformationContainer>
        </>
      )}

      {(quote.company_id === 23 && quote.product_id == 1) && (
        <>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>{quote?.company?.name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Guida:</h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationItem>
            {quote?.risk_massimale && (
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  {quote.risk_massimale}
                </p>
              </QuoteInformationItem>
            )}
          </QuoteInformationContainer>
        </>
      )}
    </>
  );
}

export default QuoteInfoComponent;
